import { Perm, perm_gen_auto, PermDpyGroup } from './perms'

const auto = perm_gen_auto()

const PERMS_SIZE = 32

export class StaffPerms {
    static MANAGER: Perm = auto()

    static V_USER: Perm = auto()
    static A_USER: Perm = auto()
    static C_USER: Perm = auto()
    static D_USER: Perm = auto()

    static V_HELMET: Perm = auto()
    static A_HELMET: Perm = auto()
    static C_HELMET: Perm = auto()
    static D_HELMET: Perm = auto()

    #perms: number[]
    constructor(perms: number[]) {
        perms = perms.map(p => Math.min(p, 255))

        for (let i = PERMS_SIZE - perms.length; i > 0; i--) {
            perms.push(0)
        }

        perms = perms.slice(0, PERMS_SIZE)
        this.#perms = perms
    }

    any(): boolean {
        for (let p of this.#perms) {
            if (p != 0) return true
        }
        return false
    }

    any_of(...perms: Perm[]): boolean {
        for (let p of perms) {
            if (this.get(p)) return true
        }

        return false
    }

    check(...perms: Perm[]): boolean {
        if (this.get(StaffPerms.MANAGER)) return true

        for (let p of perms) {
            if (!this.get(p)) return false
        }

        return true
    }

    get({ byte, bit }: Perm): boolean {
        if (byte >= this.#perms.length) {
            throw new Error('invalid byte')
        }
        let f = 1 << bit
        let n = this.#perms[byte]!
        return (n & f) == f
    }

    set({ byte, bit }: Perm, value: boolean) {
        if (byte >= this.#perms.length) {
            throw new Error('invalid byte')
        }
        let f = 1 << bit
        if (value) {
            this.#perms[byte]! |= f
        } else {
            this.#perms[byte]! &= ~f
        }
    }

    toggle(perm: Perm) {
        this.set(perm, !this.get(perm))
    }

    get perms(): number[] {
        return this.#perms
    }
}
// @ts-ignore
delete globalThis.auto

export const STAF_PERMS_DISPLAY: PermDpyGroup[] = [
    {
        name: 'manager',
        perms: [{ perm: StaffPerms.MANAGER, name: 'manager' }],
    },
    {
        name: 'users',
        perms: [
            {
                perm: StaffPerms.V_USER,
                name: 'view',
            },
            {
                perm: StaffPerms.A_USER,
                name: 'add',
            },
            {
                perm: StaffPerms.C_USER,
                name: 'change',
            },
            {
                perm: StaffPerms.D_USER,
                name: 'delete',
            },
        ],
    },
]
